import React from 'react'
import './Footer.css'
import { FiTwitter } from 'react-icons/fi'
import {FiInstagram} from 'react-icons/fi'
const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>DOMAINS18</a>

      <ul className="permalinks">
        <li> <a href="#nav"> Home</a></li>
        <li> <a href="#about"> About</a></li>
        <li> <a href="#contacts"> Contacts</a></li>
        <li> <a href="#experience"> Expereince</a></li>
        <li> <a href="#servicec"> Services</a></li>
        <li> <a href="#portfolio"> Portfolio</a></li>
        <li> <a href="#testimonials"> Testimonials</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://twitter.com/eightsville"> <FiTwitter/> </a>
        <a href="https://instagram.com/tweetofsins"> <FiInstagram/> </a>
      </div>
      <div className="footer__copyright">
        <small>
          &copy; Domains18. All Rights Reserved.
        </small>
      </div>
    </footer>
  )
}

export default Footer